<template>
    <ContentOrLoading>
        <template v-if="!loading">
            <b-col cols="12" class="pl-0 pr-0">
                <FormInput label="Asunto" type="text" name="asunto" id="asunto" rules="required" v-model="comunicado.asunto" />
            </b-col>
            <b-col cols="12" class="pl-0 pr-0">
                <div class="form-group">
                    <label for="fecha de envío">Fecha de envio</label>
                    <ValidationProvider name="fecha de envío" rules="required" v-slot="{ errors }">
                        <datetime
                            v-model="comunicado.fecha_envio"
                            :input-class="'form-control ' + (errors[0] ? 'is-invalid' : '')"
                            :min-datetime="new Date().toISOString()"
                            type="datetime"
                            input-id="fecha_envio"
                            value-zone="CET"
                        />
                        <span v-if="errors[0]" class="d-block invalid-feedback text-xs bg-danger white h7 mb-4 p-2 font-weight-bold">{{ errors[0] }}</span>
                    </ValidationProvider>
                </div>
            </b-col>
            <b-col cols="12" class="pl-0 pr-0">
                <div class="form-group">
                    <label for="nombre">Listo para enviar</label>
                    <ValidationProvider name="enviar" rules="required" v-slot="{ errors }">
                        <select id="enviar" :class="'form-control ' + (errors[0] ? 'is-invalid' : '')" v-model="comunicado.listo_para_enviar">
                            <option value="0">No</option>
                            <option value="1">Si</option>
                        </select>
                        <span v-if="errors[0]" class="d-block invalid-feedback text-xs bg-danger white h7 mb-4 p-2 font-weight-bold">{{ errors[0] }}</span>
                    </ValidationProvider>
                </div>
            </b-col>
            <b-col cols="12" class="pl-0 pr-0">
                <div class="form-group">
                    <label for="email">Enviar a:</label>
                    <ValidationProvider name="objetivo" rules="required" v-slot="{ errors }">
                        <select :class="'form-control ' + (errors[0] ? 'is-invalid' : '')" id="objetivo" v-model="comunicado.enviar_a">
                            <option value="1" selected>Todos los abonados + emails alternativos</option>
                            <option value="2">Todos los compradores de un evento</option>
                            <option value="3">Una lista personalizada</option>
                            <option value="4">Todos los emails recopilados de recordatorios</option>
                        </select>
                        <span v-if="errors[0]" class="d-block invalid-feedback text-xs bg-danger white h7 mb-4 p-2 font-weight-bold">{{ errors[0] }}</span>
                    </ValidationProvider>
                </div>
            </b-col>
    
            <template v-if="comunicado.enviar_a == 2">
                <b-col cols="12" class="pl-0 pr-0">
                    <div class="form-group">
                        <label for="provincias">Seleccionar evento</label>
                        <ValidationProvider name="evento">
                            <multiselect 
                                placeholder="Eventos"
                                :options="eventos"
                                :value="eventos.id"
                                id="eventos"
                                label="name"
                                track-by="id"
                                v-model="comunicado.evento_id"
                            />
                        </ValidationProvider>
                    </div>
                </b-col>
            </template>
    
            <template v-if="comunicado.enviar_a == 3">
                <b-col cols="12" class="pl-0 pr-0">
                    <div class="form-group">
                        <label for="provincias">Seleccionar base</label>
                        <ValidationProvider name="base" rules="required" v-slot="{ errors }">
                            <multiselect 
                                placeholder="Deportistas"
                                :options="bases"
                                :value="bases.id"
                                id="bases"
                                label="nombre"
                                track-by="id"
                                v-model="comunicado.base"
                            />
                            <span v-if="errors[0]" class="d-block invalid-feedback text-xs bg-danger white h7 mb-4 p-2 font-weight-bold">{{ errors[0] }}</span>
                        </ValidationProvider>
                    </div>
                </b-col>
            </template>
    
            <b-col cols="12" class="pl-0 pr-0">
                <FormInput label="Título" type="text" name="titulo" id="titulo" rules="required" v-model="comunicado.titulo" />
            </b-col>
            <b-col cols="12" class="pl-0 pr-0">
                <div class="form-group">
                    <label for="nombre">Contenido</label>
                    <ValidationProvider name="contenido" rules="required" v-slot="{ errors }">
                        <CkEditorComponent v-model="comunicado.contenido"/>
                        <span v-if="errors[0]" class="d-block invalid-feedback text-xs bg-danger white h7 mb-4 p-2 font-weight-bold">{{ errors[0] }}</span>
                    </ValidationProvider>
                </div>
            </b-col>
        </template>
    </ContentOrLoading>
</template>

<script>
    import CkEditorComponent from '@/components/common/forms/CkEditorComponent.vue';

    export default {
        props: {
            comunicado: {
                type: Object,
                required: true
            },
            loading: {
                type: Boolean,
                required: true
            }
        },
        data() {
            return {
                eventos: [],
                bases: [],
            }
        },
        methods: {
            getEvents() {
                this.updateLoading(true);

                const data = {
                    filters: {
                        to_select: true
                    }
                };

                this.$store.dispatch(this.config.getVuexAlias('back.events.index'), data).then(res => {
                    this.eventos = res.data.data;
                    if(this.comunicado.evento_id) {
                        this.comunicado.evento_id = this.eventos.find(evento => evento.id === this.comunicado.evento_id);
                    }

                }).catch(error => {
                    this.$toast.error(error.response?.data?.message);
                }).finally(() => {
                    this.updateLoading(false);
                });
            },
            getBases() {
                this.updateLoading(true);

                const params = {
                    filters: {
                        to_select: true
                    }
                }

                this.$store.dispatch(this.config.getVuexAlias('back.comunicados.bases.index'), params).then(res => {
                    this.bases = res.data.data;
                    if (this.comunicado?.base_id) {
                        this.comunicado.base = this.bases.find(base => base.id === this.comunicado.base_id);
                    }
                }).catch(error => {
                    this.$toast.error(error.response?.data?.message);
                }).finally(() => {
                    this.updateLoading(false);
                });
            },
            updateLoading(estado) {
                this.$emit('update:loading', estado)
            }
        },
        created() {
            this.getEvents();
            this.getBases();
        },
        components: {
            CkEditorComponent
        }
    }
</script>